<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">货物信息：</span>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="goods"
        class="my-form"
        title-align="right"
        :data="formData"
        :rules="formRules"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="货物类型" field="goodsType" span="8">
        <template v-slot>
          <vxe-select v-model="formData.goodsType" :options="goodsTypeOptions" @change="clearValidate"
                      placeholder="请选择"></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="货名" field="goodsName" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.goodsName" placeholder="必填" clearable
                     @input="$refs.goods.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="单位" field="pack" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.pack" placeholder="必填" clearable
                     @input="$refs.goods.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="合同数量" field="goodsCount" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.goodsCount" type="float" :digits="3" max="999999.999" placeholder="必填" clearable
                     @input="$refs.goods.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="含税" field="isTax" span="8">
        <template v-slot>
          <vxe-select v-model="formData.isTax" :options="taxType" @change="clearValidate"
                      placeholder="请选择"></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="计费方式" field="priceText" span="8">
        <template v-slot>
          <vxe-select v-model="formData.priceText" :options="busType === 2 ? priceType1 : priceType2"
                      @change="clearValidate" placeholder="请选择"></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="运价(元)" field="price" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.price" type="float" :digits="2" placeholder="必填" clearable
                     @input="$refs.goods.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
  import $C from "@/consts";

  export default {
    props: ['goodsTypeOptions', 'busType', 'isSubmit', 'isCancel', 'isSave', 'detailData'],
    data() {
      return {
        formData: {
          goodsType: null,
          goodsName: null,
          pack: null,
          goodsCount: null,
          isTax: null,
          priceText: null,
          price: null,
        },
        formRules: {
          goodsType: [{required: true, message: "请选择货物类型"}],
          goodsName: [{required: true, message: "请输入货名"},{max: 10, message: "货名最多10字"}],
          pack: [{required: true, message: "请输入单位"},{max: 10, message: "单位最多10字"}],
          goodsCount: [{required: true, message: "请输入合同数量"}],
          isTax: [{required: true, message: "请选择是否含税"}],
          priceText: [{required: true, message: "请选择计费方式"}],
          price: [{required: true, message: "请输入运价(元)"}],
        },
        taxType: [{
          label: '是',
          value: '是'
        },
          {
            label: '否',
            value: '否'
          }
        ], // 是否含税类型选择框,
        priceType1: [
          {
            label: '单价',
            value: '单价'
          },
          {
            label: '包车',
            value: '包车'
          }
        ],
        priceType2: [
          {
            label: '单价',
            value: '单价'
          },
          {
            label: '包船',
            value: '包船'
          }
        ],
      };
    },
    watch: {
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.formData = {
            goodsType: this.detailData.goodsType,
            goodsName: this.detailData.goodsName,
            pack: this.detailData.pack,
            goodsCount: this.detailData.goodsCount,
            isTax: this.detailData.isTax,
            priceText: this.detailData.priceText,
            price: this.detailData.price,
          }
        }
      }
    },
    methods: {
      async check() {
        const errMap = await this.$refs.goods.validate().catch(errMap => errMap);
        if (errMap) {
          this.$emit("setParams", false);
          return
        }
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          goodsType: this.formData.goodsType,
          goodsName: this.formData.goodsName,
          pack: this.formData.pack,
          goodsCount: this.formData.goodsCount,
          isTax: this.formData.isTax,
          priceText: this.formData.priceText,
          price: this.formData.price,
        };
        this.$emit("setParams", obj);
      },
      reset() {
        this.formData = {
          goodsType: null,
          goodsName: null,
          pack: null,
          goodsCount: null,
          isTax: null,
          priceText: null,
          price: null,
        };
        this.clearValidate();
      },
      clearValidate() {
        this.$refs.goods.clearValidate();
      },
    }
  };
</script>

<style scoped>

</style>